/**
 * Product card image carousel swipe tracking.
 *
 * Pushes a `product_card_swipe` event to the dataLayer (Elevar/GTM -> GA4) each
 * time a card's image carousel settles on a different image, so we can measure
 * whether the swipe-to-lifestyle-image treatment is being discovered at all.
 *
 * Fires on EVERY swipe rather than once per card per session — GA4 can collapse
 * that to "% of users who swiped" at query time, but a cap in the theme would
 * permanently lose the "how often" half of the question.
 *
 * Event params: product_handle, product_id, item_list_name, image_index (0-based,
 * 0 = the hero image), image_count, device.
 *
 * Fire-and-forget: the handler is wrapped so it can never break the carousels.
 */
(() => {
  "use strict";

  // Elevar's app embed creates this, but it loads async and may be blocked by
  // consent — a local array keeps pushes safe and lets GTM drain them later.
  window.dataLayer = window.dataLayer || [];

  // Last reported index per carousel. `carousel:settle` also fires when a scroll
  // ends on the image it started from (a nudge that snapped back), which is not
  // a swipe worth recording.
  const lastIndex = new WeakMap();

  document.addEventListener("carousel:settle", (event) => {
    try {
      const carousel = event.target;
      if (!(carousel instanceof Element)) return;
      if (!carousel.matches(".product-card__ls-carousel")) return;

      const index = event.detail && event.detail.index;
      if (typeof index !== "number") return;
      if (lastIndex.get(carousel) === index) return;
      lastIndex.set(carousel, index);

      window.dataLayer.push({
        event: "product_card_swipe",
        product_handle: carousel.dataset.trackProductHandle || "",
        product_id: carousel.dataset.trackProductId || "",
        item_list_name: carousel.dataset.trackList || "",
        image_index: index,
        image_count: carousel.dataset.trackImageCount || "",
        device: carousel.classList.contains("product-card__ls-carousel--mobile") ? "mobile" : "desktop",
      });
    } catch (error) {
      console.error("product card swipe handler failed.", error);
    }
  });
})();
